import * as React from 'react';
import List from '../components/List';

const MENU_KEY = 'review_quote';

export default class ReviewQuote extends React.Component<any, any> {
  public render() {
    return <List menuKey={MENU_KEY} {...this.props}/>;
  }
}
